<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.secureFlowStepsAction.title' | labelsProvider }}
    </div>
    <div class="disclaimer">
      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.secureFlowStepsAction.actionOverviewHeader' | labelsProvider }}
      </div>
      <div>
        {{ 'commonActions.secureFlowStepsAction.actionOverviewTitle' | labelsProvider }}
      </div>
      <div>
        <ul>
          <li>
            {{ 'commonActions.secureFlowStepsAction.actionOverviewDescription.sensitiveData' | labelsProvider }}
          </li>
        </ul>
      </div>
      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.secureFlowStepsAction.howItWorksHeader' | labelsProvider }}
      </div>
      <div class="how-it-works-description">
        {{ 'commonActions.secureFlowStepsAction.howItWorksDescription' | labelsProvider }}
      </div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="supported-rules-header">
                {{ 'commonActions.secureFlowStepsAction.supportedRulesHeader' | labelsProvider }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (rule of supportedRulesIdAndDescription; track rule) {
            <li class="disclaimer-rules">
              {{ rule }}
            </li>
          }
        </mat-expansion-panel>
      </mat-accordion>

      <div class="sub-headers-rules-and-limitation">
        {{ 'commonActions.secureFlowStepsAction.limitationsHeader' | labelsProvider }}
      </div>
      <div class="disclaimer-limitation">
        {{ 'commonActions.secureFlowStepsAction.limitationsDisclaimer' | labelsProvider }}
      </div>
    </div>
  </div>
</div>
